<template>
    <mdb-container v-if="newsByCategory" fluid>
        <mdb-row>
            <mdb-col sm="12" class="mb-5" v-for="news in newsByCategory" :key="news.id">
                <mdb-card class="wider news" cascade test>
                    <mdb-card-body cascade>
                        <h4 class="card-header-title mb-3" v-html="news.title"></h4>
                        <div class="mb-3" style="color: #0056b3"><time>{{formatDate(news.date)}}</time></div>
                        <mdb-card-text v-html="news.anons" ></mdb-card-text>
                        <router-link class="primary-text mt-1 d-flex flex-row-reverse" :to="'/news/' + news.id">
                            <h5 class="p-2" waves>Подробнее <mdb-icon icon="angle-double-right" /></h5>
                        </router-link>
                    </mdb-card-body>
                </mdb-card>
            </mdb-col>
        </mdb-row>
    </mdb-container>
</template>

<script>

    import axios from 'axios';
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardText,
        mdbIcon
    } from "mdbvue";
    import store from "../../store";

    export default {
        name: "listing",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody,
            mdbCardText,
            mdbIcon
        },
        data() {
            return {
                newsByCategory: null,
                category: null
            }
        },
        watch: {
            $route() {
                axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/news?fields=*.*&filter[news_category][_eq]='+ this.$route.params.id +'&sort=-date&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                    .then(response => {
                        this.newsByCategory = response.data.data;
                        this.category = response.data.data[0].news_category.title;
                        store.commit('setBreadcrumbs',['Новости', this.category]);
                    });
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/news?fields=*.*&filter[news_category][_eq]='+ this.$route.params.id +'&sort=-date&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                    this.newsByCategory = response.data.data;
                    this.category = response.data.data[0].news_category.title;
                    store.commit('setBreadcrumbs',['Новости', this.category]);
                });
        },
        methods: {
            formatDate: function(dateTime){
                let date = new Date(dateTime);

                const monthNames = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
                ];

                let day = date.getDate()

                let month = monthNames[date.getMonth()]

                let year = date.getFullYear()

                let hours = date.getHours()

                let minutes = date.getMinutes()

                return day + ' ' + month + ' ' + year + '  ' + hours + ':' + minutes;
            }
        }
    }
</script>

<style >
    .news .card-text h3{
        font-size: .9rem;
        font-weight: 400;
    }
</style>
